import React from 'react'

import FormattedMessage from 'components/FormattedMessage'
import Button from 'components/Button'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const FencingCard: React.FC<FencingCardProps> = ({ className }) => {
  return (
    <div
      className={classNames(styles, 'fencing-card', className)}
    >
      <div className={classNames(styles, 'fencing-card__content')}>
        <div className={classNames(styles, 'fencing-card__content__head')}>
          <FormattedMessage id="subscription.fencingcard.title" />
        </div>

        <div className={classNames(styles, 'fencing-card__content__body')}>
          <FormattedMessage id="subscription.fencingcard.body" />
        </div>

        <div className={classNames(styles, 'fencing-card__content__footer')}>
          <Button
            size="large"
            type="primary"
            href="https://business.eventinc.de/gesamtes-portfolio"
            target="_blank"
            translationKey="subscription.badge.upgrade"
            className={classNames(
              styles,
              'fencing-card__content__footer__button',
              'ant-btn--with-border-radius-large',
              'ant-btn--brand-font',
            )}
          />
        </div>
      </div>
    </div>
  )
}

interface FencingCardProps { className?: string}

export default FencingCard
